import { configureStore } from "@reduxjs/toolkit";
import customerSessionReducer from "./customerSessionSlice";
import signalRReducer from "./signalRSlice";

export const store = configureStore({
  reducer: {
    customerSession: customerSessionReducer,
    signalR: signalRReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
